import { useRef, useCallback, useState } from 'react'
import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Fade } from '../ui/Fade'
import { Logo } from '../ui/Logo'
import { ConsultModal } from '../components/ConsultModal'

export default function CtaBand({ onLogin, isAuthenticated, onGoApp }) {
  const secRef   = useRef(null)
  const gridRef  = useRef(null)
  const mouseRef = useRef({ x: 0.5, y: 0.5 })
  const rafRef   = useRef(null)
  const [modal, setModal] = useState(false)

  const applyTilt = useCallback(() => {
    const { x, y } = mouseRef.current
    if (gridRef.current) {
      gridRef.current.style.transform =
        `perspective(700px) rotateX(${(y - 0.5) * -14}deg) rotateY(${(x - 0.5) * 14}deg)`
    }
    rafRef.current = null
  }, [])

  const onMouseMove = useCallback(e => {
    const r = secRef.current?.getBoundingClientRect()
    if (!r) return
    mouseRef.current = { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height }
    if (!rafRef.current) {
      rafRef.current = requestAnimationFrame(applyTilt)
    }
  }, [applyTilt])

  const onMouseLeave = useCallback(() => {
    mouseRef.current = { x: 0.5, y: 0.5 }
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null }
    if (gridRef.current) {
      gridRef.current.style.transform = 'perspective(700px) rotateX(0deg) rotateY(0deg)'
    }
  }, [])

  return (
    <>
      <section
        ref={secRef}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        style={{ background: C.bg1, padding: '96px 0', position: 'relative', overflow: 'hidden' }}
      >
        {/* Mouse-tilt grid */}
        <div ref={gridRef} style={{ position: 'absolute', inset: -80, zIndex: 0, pointerEvents: 'none', transition: 'transform 0.22s ease' }}>
          <div style={{ position: 'absolute', inset: 0, backgroundImage: `linear-gradient(rgba(31,200,214,.2) 1px,transparent 1px),linear-gradient(90deg,rgba(31,200,214,.2) 1px,transparent 1px)`, backgroundSize: '44px 44px', animation: 'ctaGridPulse 5s ease-in-out infinite' }}/>
        </div>

        {/* Radial vignette */}
        <div style={{ position: 'absolute', inset: 0, zIndex: 1, pointerEvents: 'none', background: 'radial-gradient(ellipse 80% 80% at 50% 50%,transparent 40%,rgba(4,13,24,.75) 100%)' }}/>

        <div className="wrap" style={{ textAlign: 'center', position: 'relative', zIndex: 2 }}>
          <Fade>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
              <a href="/" aria-label="Welland Create" style={{ textDecoration: 'none' }} onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }) }}>
                <Logo s={36}/>
              </a>
            </div>

            <h2 style={{ fontSize: 'clamp(26px,4.5vw,52px)', color: '#fff', maxWidth: 700, margin: '0 auto' }}>
              Бассейн вашей мечты<br/>начинается с первого{' '}
              <span className="chrome-bright">клика</span>
            </h2>

            <div className="cta-band-row" style={{ marginTop: 36 }}>
              <button className="btn btn-p btn-lg" onClick={isAuthenticated ? onGoApp : onLogin}>
                <Ic n="cube" s={18}/>Создать проект
              </button>
              <button
                className="btn btn-g btn-lg"
                onClick={() => setModal(true)}
                style={{ border: '1px solid rgba(31,200,214,.3)', color: '#a0c8d0' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(31,200,214,.7)'; e.currentTarget.style.color = '#fff' }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(31,200,214,.3)'; e.currentTarget.style.color = '#a0c8d0' }}
              >
                <Ic n="phone" s={17}/>Получить консультацию
              </button>
            </div>

          </Fade>
        </div>
      </section>

      <ConsultModal open={modal} onClose={() => setModal(false)}/>
    </>
  )
}
